interface RaceSettleAllResponse {
  all: Array<PromiseSettledResult<any>>
  fulfilled: Array<PromiseFulfilledResult<any>>
  rejected: PromiseRejectedResult[]
}

export const ExtendedPromise = {
  delayedResolve: async function (timeoutTime: number | undefined, timeoutVal: any) {
    return await new Promise(resolve => {
      setTimeout(resolve.bind(null, timeoutVal), timeoutTime)
    })
  },
  delayedReject: async function (timeoutTime: number | undefined, timeoutVal: any) {
    return await new Promise((_resolve, reject) => {
      setTimeout(reject.bind(null, timeoutVal), timeoutTime)
    })
  },
  raceAll: async function (promises: any[], timeoutTime: any, timeoutVal: any) {
    return await Promise.all(promises.map(async p => {
      return await Promise.race([p, this.delayedResolve(timeoutTime, timeoutVal)])
    }))
  },
  isRaceSettleAllResult: function (response: any): response is RaceSettleAllResponse {
    return Object.hasOwn(response as RaceSettleAllResponse, 'all') && Array.isArray(response.all) &&
      Object.hasOwn(response as RaceSettleAllResponse, 'fulfilled') && Array.isArray(response.fulfilled) &&
      Object.hasOwn(response as RaceSettleAllResponse, 'rejected') && Array.isArray(response.rejected)
  },
  raceSettleAll: async function (promises: any[], timeoutTime: any, timeoutVal: any): Promise<{
    all: Array<PromiseSettledResult<any>>
    fulfilled: Array<PromiseFulfilledResult<any>>
    rejected: PromiseRejectedResult[]
  }> {
    const all: Array<PromiseSettledResult<any>> = []
    const fulfilled: Array<PromiseFulfilledResult<any>> = []
    const rejected: PromiseRejectedResult[] = []

    await Promise.allSettled(promises.map(async promise => {
      return await Promise.race([promise, this.delayedReject(timeoutTime, timeoutVal)])
    })).then(settledResult => {
      all.push(...settledResult)
      settledResult.forEach(result => {
        if (result.status === 'fulfilled') {
          fulfilled.push(result)
        } else {
          rejected.push(result)
        }
      })
    })

    return { all, fulfilled, rejected }
  },
}
